module.exports = __webpack_public_path__ + "static/img/search_bg.39b9b95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/search_bg.png
// module id = X+a+
// module chunks = 1